import React from 'react';
import s from './styles/SessionsPage.module.scss';

export function SessionsPage() {
  return (
    <>
      <div className={s.page}>
        <div className={`layout-content-container ${s.container}`}>
          <div className={s.topBar}>
            <p className={s.topTitle}>Sessions</p>
            <button className={s.topButton}>+ Schedule Session</button>
          </div>

          <h3 className={s.sectionTitle}>
            AI Suggested Students to Book With
          </h3>
          <div className={s.suggestedScroll}>
            <div className={s.suggestedList}>
              <div className={s.suggestedCard}>
                <div
                  className={s.suggestedImage}
                  style={{
                    backgroundImage:
                      'url("https://lh3.googleusercontent.com/aida-public/AB6AXuALc4Lx6CxNxEivnFFT_Etn4tFJi5RtXF-aYhMSmbWQ6Ae7o6FlZLTMAIXI4D_dNfW1WEVNhEuulnHcTbwKNAjjp9LQftF6ZYXW32q9seEP5zVVVk2c40gsFTR8bW-EMjMmVWjwNbKmqbkEAJ4xkd1q4cq56ms2hWdWsCCENMOmmiR53jaJo0mJr5SU6WBVXa7Ojnx95lgiiYbHT5Zj96N-2EXOWatmtplxePOa-0R3ZfflpI4LYtICPTx2NLAa-DjZ1cEsQ79FyGE")',
                  }}
                />
                <div>
                  <p className={s.suggestedName}>Omar Hassan</p>
                  <p className={s.suggestedStatus}>🚩 Needs Help</p>
                </div>
              </div>

              <div className={s.suggestedCard}>
                <div
                  className={s.suggestedImage}
                  style={{
                    backgroundImage:
                      'url("https://lh3.googleusercontent.com/aida-public/AB6AXuBQyBS630bCea2J_CEp_3ilKGYhsORTx-eYtcS-jzbTFLE99EKwkP5rqHMrfbviDEX6Hext9DXD1xbFgKm4hmSccZQnXqub9hmCrre0lp6FcBipV10qvbcZ8NMbzS525TAD5wboQZXSMptCVmDBjQ2p579N5kiKnZDrITaMRPM1AlFICeQyldDFF2L-_vpmjZN5vPwFWyNVqRRSdV92-SlQJOBXmOAmg3HJg6x6XaAWc3v5pawgPlvMZkm7rCkvCYbw_R88OlgrTwM")',
                  }}
                />
                <div>
                  <p className={s.suggestedName}>Fatima Al Ali</p>
                  <p className={s.suggestedStatus}>On Track</p>
                </div>
              </div>

              <div className={s.suggestedCard}>
                <div
                  className={s.suggestedImage}
                  style={{
                    backgroundImage:
                      'url("https://lh3.googleusercontent.com/aida-public/AB6AXuBqUsT-yg8m_v9JxjxRa0kP9ZpGvsVQKTnVjo1mMjHU-4igE7XqFuPCzHEs_AX0Q52vK8k13NSSuHCmEPQaMLv4Zj8F_2aTaNmdNNodkzPtuGQ2L-zdagrjXCZL3SGxsE-J9srebDddIz5ruWnn2EkMTYDGwYq9Xqqd_fwKdyB0KxUkRfV7TbJ6W7M-nhov4hUhXLRhTAu88qp3gypJNVIXPQyHe1AYzYlB_E87LZCFUH869VC-BE8NMx6TIfU3DHf4Agglt5nBgB4")',
                  }}
                />
                <div>
                  <p className={s.suggestedName}>Khaled Al Mansoori</p>
                  <p className={s.suggestedStatus}>🚩 Needs Help</p>
                </div>
              </div>
            </div>
          </div>

          <h3 className={`${s.sectionTitle} ${s.sectionTitleSpacingTop}`}>
            Today’s Sessions
          </h3>
          <div className={s.timelineGrid}>
            <div className={`${s.timelineColumn} ${s.timelineColumnTop}`}>
              <div
                className={s.timelineAvatar}
                style={{
                  backgroundImage:
                    'url("https://lh3.googleusercontent.com/aida-public/AB6AXuD7ME7DzuWZQatkW0REJ8XSpmbZOXAHfZHsnldiJUFJcF85QpoHfpH6g6miPGEG_FF_8LLvgZR12zU8gt6NZwaxPCqd8ezampB4z-cFU6BnC2f3dx3TXVJzFa00cFDYG0efETCh8_Bn28JvJaNFZnCoBdOjV-GZUNHFnrUysiPEuTdRPTUwaCAcGH7TBrVpOtNke1LwNFK2DmkTYeiuQHe2NCrEPq_8e4eql7jlmgfq5-efjrQFvZfhV50QdcBWNaj9dHEVmaDwFC4")',
                }}
              />
              <div className={s.timelineLine} />
            </div>
            <div className={s.timelineItem}>
              <p className={s.timelineTime}>08:30 - 09:30</p>
              <p className={s.timelineText}>
                Omar Hassan - Country Finder
              </p>
            </div>

            <div className={`${s.timelineColumn} ${s.timelineColumnCenter}`}>
              <div className={s.timelineLine} />
              <div
                className={s.timelineAvatar}
                style={{
                  backgroundImage:
                    'url("https://lh3.googleusercontent.com/aida-public/AB6AXuAfJSRwTVABYj5Sg0BePni5mI_eA9EvswbmTACeelR3jCoMqWE1fbzBgrhZHodca5cpMG1KEewZWb1NwseqokImQhOtwHNt6VPVQdOzeRe4VKsDDOmE0qE652-KTAhCNHxlsqpNvE5qKXu2JDjjAMVs4PIB8wn99hdZe3U0XmM6GXLRAVFH7CPwk0c-P7TL0fwH7Wuh2g8WaBukAEw4pq3mmOCk8jvTwlFn14CSPtuicHrZhq2_aG6aQ70r4Aw2H_Jamqx0qDJK0jc")',
                }}
              />
              <div className={s.timelineLine} />
            </div>
            <div className={s.timelineItem}>
              <p className={s.timelineTime}>10:00 - 11:00</p>
              <p className={s.timelineText}>
                Fatima Al Ali - Career Review
              </p>
            </div>

            <div className={`${s.timelineColumn} ${s.timelineColumnBottom}`}>
              <div className={s.timelineLine} />
              <div
                className={s.timelineAvatar}
                style={{
                  backgroundImage:
                    'url("https://lh3.googleusercontent.com/aida-public/AB6AXuDRB2zkyHJt5VJPZqGJCfxsxQBvSoOAbJ_FrGx3OzlJJXtAXjPf5ZxU-6J_bnETX5rKQqwwPfGayKnis51LFDTAxOgcVnrBkJV80u5i0Fs25x8RHgh5E4316ZR-_7aOoIg4hRvMu-5idp_vpAw-aNkrM__dnp1tLMjfpvDjF_LGQBLFFyHQnczqQSCdMowwvHyu9Zi7XKd_OBQWn0oIw2oOVHSVLYEPp5Svnn14y3Oz4SwdX7YvInUnN070yZDwKWtT7gGbVVmoXRg")',
                }}
              />
            </div>
            <div className={s.timelineItem}>
              <p className={s.timelineTime}>14:00 - 15:00</p>
              <p className={s.timelineText}>
                Khaled Al Mansoori - SOP Review
              </p>
            </div>
          </div>

          <h3 className={s.sectionTitle}>
            Notes for: Omar Hassan · Country Finder Review · 08:30-09:30
          </h3>
          <div className={s.notesWrapper}>
            <textarea
              placeholder="Start typing your notes here..."
              className={s.notesTextarea}
              rows={4}
            />
          </div>
          <p className={s.notesStatus}>✅ Notes Saved</p>
        </div>
      </div>

      <div className={s.viewToggle}>
        <div className={s.viewToggleInner}>
          <label className={s.viewToggleOption}>
            <span className={s.viewToggleLabel}>List</span>
            <input
              type="radio"
              className={s.viewToggleInput}
              defaultChecked
            />
          </label>
          <label className={s.viewToggleOption}>
            <span className={s.viewToggleLabel}>Calendar</span>
            <input type="radio" className={s.viewToggleInput} />
          </label>
        </div>
      </div>

      <div className={s.upcomingTitleWrapper}>
        <h3 className={s.sectionTitle}>Upcoming Sessions</h3>
      </div>
      <div className={s.upcomingList}>
        <div className={s.upcomingItem}>
          <div
            className={s.upcomingAvatar}
            style={{
              backgroundImage:
                'url("https://lh3.googleusercontent.com/aida-public/AB6AXuA2Sg_GNepmwZLJ0UKkMVTx4ICM_u4N-uKDJ3-GgEkbZ5Kes1TEvRkvX4wjTTymwftv8ta9_NeitvDNxF9wtoKjGz3klQytlyeY5MpG4hZKWaZ4cTDZaIG2ZiuVGlMdKE2yzHUkhpnb3F_LFjsU304xEg23nyv9lv7VegOkiQqm6Wx7CP37pMzezBZC1XAhYA21ty2lBxhvBzcgyyCHKZy5mCLxbIU5AIbddXilHyWp1B48dMz7gCrUsUKzMzj89kOkbZVk3x8C2mo")',
            }}
          />
          <div>
            <p className={s.upcomingName}>
              Mon, Jul 21 · Omar Hassan
            </p>
            <p className={s.upcomingDetails}>
              Country Finder Review · 09:00-10:00
            </p>
          </div>
        </div>

        <div className={s.upcomingItem}>
          <div
            className={s.upcomingAvatar}
            style={{
              backgroundImage:
                'url("https://lh3.googleusercontent.com/aida-public/AB6AXuBCC9U5q9QraFht5-mKy6UL-jromnwByQpV5SS58ibsyarmEPKAbIk4GOMvKTKw2EukEq0FzJhdQJM3zv5NuLWzIoyY2fIIcIYNVF1KpKnOJ-eHLQ8AQ5FW7zreXVRFNR2xJElnU-Q0akCIRZ1LHZ4EPSkWb7dKFhrQ6lifgfEeZFiKF49c1VIHB-14pgOryIMh6yJy7miA55_b4vRIPleBQ3zN_8I69v7sFqylDiaSiH9cS6khlpGWY9Kn86DatjF-SXzkdVlSF64")',
            }}
          />
          <div>
            <p className={s.upcomingName}>
              Tue, Jul 22 · Fatima Al Ali
            </p>
            <p className={s.upcomingDetails}>
              Career Finder Review · 11:00-12:00
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
